import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const SecondPage = () => (
  <Layout>
  <div className="masthead-followup row m-0 bg-white border border-white text-center">
  <div className="col-12 col-md-12 p-md-3 bg-white border border-white text-center"></div>
   <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-dark lead text-center">
   <Seo title="MESIN KASIR ONLINE" />
   <h2><strong>MESIN KASIR ONLINE</strong></h2>
   <p>
 Selamat datang di website mesin kasir online app , solusi aplikasi kasir online dalam kebutuhan pembukuan dan transaksi usaha mu, dunia dalam genggaman anda.
 Terbaik digunakan pada usaha retail shop store minimarket supermarket toko modern hingga restoran cafe rumah makan all in one kompleks system.
 </p>
 <Link to="#start" className="button" title="lets go..!!">Get Started &rarr;</Link>
 </div>
   <div class="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-dark lead text-center">
   <img alt="mesin kasir online" width="400" className="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1579757789/mobilepos_fj6mmo.jpg"/>
     <h3 id="start"><strong>MOBILE POS ON THE GO</strong></h3>
   <p>
Sensasi dalam kebutuhan untuk bertransaksi hingga cek pembukuan via smartphone mu secara langsung live real time online, inilah solusi revolusi digital dalam menunjang pekerjaan dalam operasional system digunakan.
</p>
</div>
   <div className="col-12 col-md-4">
     <div className="shadow p-3 p-md-5 bg-white rounded border border-white text-dark lead text-center">
   <h3><strong>RETAIL</strong></h3>
   <img alt="kasir retail supermarket minimarket" className="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1568371406/add-shopping-cart_ndqf9v.png"/>
   <p>
Solusi untuk supermarket minimarket retail shop store toko outlet modern system hingga apotik bengkel dan berbagai usaha retail lain nya.
<br/><Link to="/kasir" title="software kasir program kasir">More info →</Link>
</p>
</div>
</div>
<div className="col-12 col-md-4">
     <div className="shadow p-3 p-md-5 bg-white rounded border border-white text-dark lead text-center">
     <h3><strong>RESTO</strong></h3>
   <img alt="kasir resto cafe rumah makan kuliner" className="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1568371459/food_ew6ipe.png"/>
   <p>
Terbaik untuk usaha kuliner warung rumah makan restoran cafe hingga warungkopi angkringan coffee shop dan berbagai usaha kuliner drink shop lain.
<br/><Link to="/resto" title="restoran aplikasi">More info →</Link></p>
</div></div>
<div className="col-12 col-md-4">
     <div className="shadow p-3 p-md-5 bg-white rounded border border-white text-dark lead text-center">
     <h3><strong>OFFICE</strong></h3>
       <img alt="office bisnis" className="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1568371774/purchase-order_loc3rm.png"/>
 <p>
Kebutuhan untuk pembukuan office dan bisnis dalam pencatatan serta penerbitan invoice faktur pajak penjualan dan pencatatan tender project.
<br/><Link to="/office" title="invoice">More info →</Link></p>
</div></div>
   <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-dark lead text-center">
   <p>Dukungan framework aplikasi kasir online dan software program kasir offline desktop untuk menunjang usaha mu</p>
   <Link to="#hardware" className="btn btn-outline-dark rounded-circle btn-lg" title="pilih paket kasir">&darr;</Link>
   </div>
   <div className="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-dark lead text-center">
   <img alt="mesin kasir online" className="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1579757791/mesinkasirlengkap_mwaeue.jpg"/>
     <h3 id="hardware"><strong>POINT OF SALE SET</strong></h3>
   <p>
paket set mesin kasir murah baik offline desktop mode maupun online system free installasi dan setting siap digunakan dalam menunjang usaha anda, menjadi lebih baik dengan injeksi program aplikasi kasir plus pembukuan backoffice sesuai dengan bidang usaha mu.
</p>
</div>
<div className="col-12 col-md-6">
     <div className="shadow p-3 p-md-5 bg-white rounded border border-white text-dark lead text-center">
     <h3><strong>HYBRID</strong></h3>
   <p>
Touchscreen technology portable tablet pos by hewllet packard mewah dan elegan dengan harga murah.
<br/><Link to="/hybrid" title="tablet pos">More info →</Link></p>
</div></div>
<div className="col-12 col-md-6">
     <div className="shadow p-3 p-md-5 bg-white rounded border border-white text-dark lead text-center">
     <h3><strong>TOUCHSCREEN</strong></h3>
   <p>
All in one touchscreen point of sale by ASUS technology dengan fashionable design stylish dan slim.
<br/><Link to="/touchscreenpos" title="touchscreen POS">More info →</Link></p>
</div></div>
         <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-dark lead text-center">
   <p>Pilih mesin kasir murah sesuai dengan kebutuhan usaha mu, dan hubungi kami untuk informasi dan konsultasi.</p>
   <a href="#contact" className="btn btn-outline-dark rounded-circle btn-lg" title="hubungi kasir">&darr;</a>
   </div>  	  	
   <div className="col-12 col-md-12 p-3 p-md-3 bg-white border border-white text-dark lead text-center" id="contact">
     <h3><strong>Contact Us</strong></h3>
   <p>
Hubungi team mesin kasir online applikasi.
</p>
<a href="https://wa.me/6285646104747" rel="nofollow" className="button">Chat Now</a> <a href="tel:+6285331361404" rel="nofollow" className="button">Call Us</a> <a href="mailto:hockeycorpmarketing@gmail.com" rel="nofollow" className="button">Email</a>
</div>
 </div>

 </Layout>
)

export default SecondPage
